import React from 'react';
import { Provider } from 'react-redux';
import store from 'react/redux/store/store';
import MatchDock from 'react/dock/MatchDock';
import { renderIntoContainer } from 'react/root/containerRoot';

// Mounts the match dock on the root views/web/layout/flatlab.php prints for a
// logged-in user, outside #page_content, so it stays mounted across client
// navigation. It renders only on the client: what it shows comes from the
// store and the socket. Returns false on pages without the root.
export default function mountMatchDock(rootDocument = document) {
	const root = rootDocument.getElementById('match_dock_root');
	if(!root) {
		return false;
	}
	renderIntoContainer(<Provider store={store}><MatchDock /></Provider>, root);
	return true;
}
